<template>
  <div class="agentCollabConfig">
    <Breadtabsheader/>
    <div class="h-piece h-mrt30" style="margin:20px">
      <div class="h-formBox">
        <el-form :inline="true" ref="ruleForm" :model="ruleForm" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="经销商名称">
              <el-input v-model="ruleForm.agentName" placeholder="请输入经销商名称" clearable></el-input>
            </el-form-item>

            <el-form-item label="订单类型" class="h-elformWrap-2" prop="orderType">
              <brselect :multiple="true" category="xiaoshou_quyu_nwx"
                        :v="ruleForm.orderType"
                        v-model="ruleForm.orderType"
                        :clearable="true"
              />
            </el-form-item>

            <el-form-item label="是否协同收入">
              <el-select v-model="ruleForm.isXietong" placeholder="请选择" clearable>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批状态">
              <el-select v-model="ruleForm.status" placeholder="请选择" clearable>
                <el-option label="正常" value="1"></el-option>
                <el-option label="审批中" value="2"></el-option>
                <el-option label="已驳回" value="3"></el-option>
              </el-select>
            </el-form-item>
          <!--  <el-form-item label="状态">
              <el-select v-model="ruleForm.delflag" placeholder="请选择" clearable>
                <el-option label="可用" value="1"></el-option>
                <el-option label="作废" value="0"></el-option>
              </el-select>
            </el-form-item>-->
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <el-button class="h-btn h-formBtn" @click="handleAdd">新增</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-table h-mrt30" style="margin:20px">
      <el-table ref="multipleTable" :data="tableData"
                stripe style="width: 100%"  :border="true" max-height="460">
        <el-table-column prop="agentCode" label="经销商编码" min-width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="agentName" label="经销商名称" min-width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="gscode" label="公司编码" min-width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="orderType" label="订单类型" min-width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
              {{scope.row.orderType | dictname('xiaoshou_quyu_nwx')}}
          </template>
        </el-table-column>
        <el-table-column prop="isXietong" label="是否协同收入" min-width="120" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.isXietong ==='1'">是</span>
            <span v-if="scope.row.isXietong ==='0'">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="cuname" label="创建人" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="cdate" label="创建时间" min-width="160" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="delflag" label="状态" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">审批中</span>
            <span v-if="scope.row.status == 3">已驳回</span>
          </template>
        </el-table-column>

    <!--    <el-table-column prop="delflag" label="状态" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.delflag == 1">可用</span>
            <span v-if="scope.row.delflag == 0">作废</span>
          </template>
        </el-table-column>-->
        <el-table-column fixed="right" label="操作" min-width="200">
          <template slot-scope="scope">
            <div style="text-align: left;">
              <el-button size="small" class="h-tableLink h-btn" @click="handleEdit(scope.row)">修改</el-button>
              <el-button v-show="scope.row.delflag == 1" size="small" class="h-tableLink h-btn" @click="delOrRes(scope.row.id,0)">删除</el-button>
              <el-button v-show="scope.row.delflag == 0" size="small" class="h-tableLink h-btn" @click="handleEdit(scope.row)">重新提交</el-button>
              <el-button
                      v-if="null != scope.row.instid && '' != scope.row.instid"
                      type="text"
                      size="small"
                      class="h-tableLink h-btn"
                      @click="genzongLiuch(scope.row)">
                跟踪
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="h-tableB h-mrt30">
        <div class="h-tableBL" style="margin-left:20px">
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
          <uploaddownexcel
                  :visible.sync="uploaddownexcelflag"
                  v-if="uploaddownexcelflag"
                  clsname="bsc_agent_collab_excel"
                  :startrow="2"
                  :extparams="ruleForm"
                  @callback="uploadExcelFilecallback"/>
        </div>
        <div class="h-pagination2">
          <pagination :page="ruleForm" @query="query" />
        </div>
      </div>
    </div>

    <!--新增修改弹窗-->
    <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>{{dialogTitle}}</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine">
        <el-form :model="order" ref="add" :inline="true"
                 label-width="100" :rules="editFormRules"
                 class="demo-ruleForm h-formbLine h-dialogForm">

          <el-form-item label="经销商名称" prop="agentName">
            <el-select v-model="order.agentName" remote filterable :filter-method="searchAgentList" clearable
                       placeholder="请选择经销商" style="width:100%" @change="agentChangeHandle">
              <el-option v-for="item in agentSelectList" :key="item.usercode"
                         :label="item.username+'-'+item.usercode" :value="item.usercode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经销商编码" prop="agentCode">
            <el-input placeholder="输入名称自动带出" v-model="order.agentCode" readonly disabled></el-input>
          </el-form-item>
          <el-form-item label="销售公司" prop="gscode">
            <brselect category="xsyb_gongsi" v-model="order.gscode" :v="order.gscode" clearable></brselect>
          </el-form-item>
          <el-form-item label="订单类型" prop="orderType">
            <brselect :multiple="true" category="xiaoshou_quyu_nwx"
                      :v="order.orderType"
                      v-model="order.orderType"
                      :clearable="true"
            />
          </el-form-item>
          <el-form-item label="是否协同收入" prop="isXietong">
            <el-select v-model="order.isXietong" clearable placeholder="请选择">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="handleSave()" v-if="!disEdit">确 定</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="handleUpdate()" v-if="disEdit">修 改</el-button>
      </div>
    </el-dialog>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  </div>
</template>

<script>
  import ss from "../../../api/SystemService";
  import uploaddownexcel from "../../../components/uploaddown/uploaddownexcel";

  export default {
    components: {
      uploaddownexcel
    },
    data() {
      return {
        ruleForm: {
          agentCode: '',
          agentName: '',
          gscode: '',
          orderType: '',
          isXietong: '',
          delflag: '',
          pageSize: 10,
          pageNo: 1,
          total: 0
        },
        tableData: [],
        showDialog: false,
        instid:null,
        showhistory:false,
        dialogTitle: '新增经销商协同配置',
        disEdit: false,
        order: {
          id: null,
          agentCode: '',
          agentName: '',
          gscode: '',
          orderType: '',
          isXietong: '',
          delflag: 1
        },
        editFormRules: {
          agentName: [{required: true, message: '请选择经销商', trigger: 'change'}],
          gscode: [{required: true, message: '请选择公司', trigger: 'change'}],
          orderType: [{required: true, message: '请选择订单类型', trigger: 'change'}],
          isXietong: [{required: true, message: '请选择是否协同收入', trigger: 'change'}]
        },
        //导入导出
        uploaddownexcelflag: false,
        agentSelectList: []
      }
    },
    methods: {
      resetData() {
        this.$refs['ruleForm'].resetFields();
      },
      query() {
        ss.orderXietong.selectPage(this.ruleForm).then(rd => {
          console.log(rd);
          this.ruleForm.total = rd.total;
          this.tableData = rd.records;
        })
      },
      exportExcel() {
        //自行对接后端导出接口
      },
      uploaddownexcelflagbtn() {
        this.uploaddownexcelflag = true;
      },
      uploadExcelFilecallback() {
        this.query();
        this.$msg.msgs('导入完成');
      },
      //弹窗-新增
      handleAdd() {
        this.dialogTitle = '新增经销商协同配置';
        this.showDialog = true;
        this.disEdit = false;
        this.order = {
          id: null,
          agentCode: '',
          agentName: '',
          gscode: '',
          orderType: '',
          isXietong: '',
          delflag: 1
        };
      },
      //弹窗-编辑赋值
      handleEdit(row) {
        console.log(row)
        this.dialogTitle = '修改经销商协同配置';
        this.showDialog = true;
        this.disEdit = true;
        this.order = {...row};
      },
      //经销商远程搜索
      searchAgentList(val) {
        ss.bscHhptAgentType.getAgent(val).then(res => {
          this.agentSelectList = res;
        })
      },
      //经销商选中回填名称
      agentChangeHandle(code) {
        let findItem = this.agentSelectList.find(item => item.usercode === code);
        if(findItem) {
          this.order.agentName = findItem.username;
          this.order.agentCode = findItem.usercode;
        }
      },
      //取消弹窗
      cancel() {
        this.showDialog = false;
        this.$refs.add.resetFields();
        this.disEdit = false;
      },
      //新增保存
      handleSave() {
        this.$refs.add.validate(valid => {
          if (!valid) return;
          ss.orderXietong.saveOrUpdateXietong(this.order).then(() => {
            this.showDialog = false;
            this.$msg.msgs('保存成功');
            this.query();
          })
        })
      },
      //修改保存
      handleUpdate() {
        this.$refs.add.validate(valid => {
          if (!valid) return;
          ss.orderXietong.saveOrUpdateXietong(this.order).then(() => {
            this.showDialog = false;
            this.$msg.msgs('修改成功');
            this.query();
          })
        })
      },
      //标记删除/恢复
      delOrRes(id, delflag) {
        this.$msg.confirm("是否确认删除?", () => {
          ss.orderXietong.delOrRes({id, delflag}).then(() => {
            this.query();
            this.$msg.msgs('操作成功');
          })
        });
      },
      genzongLiuch(r) {
        console.log(r);
        this.instid = r.instid;
        this.showhistory = true;
      },

    },
    created() {
      this.query();
    }
  }
</script>

<style scoped>
  /deep/ .h-formbLine .el-form-item__label {
    width: 100px;
  }
  /deep/ .h-formbLine .el-form-item__content {
    width: 220px;
  }
  .demo-ruleForm {
    margin-top:20px;
  }
  .yonghu .h-formbLine {
    display: flex;
    flex-wrap: wrap; /*一行放不下自动换行，保证两列布局*/
  }
  /*每个表单项占50%宽度*/
  .yonghu .h-formbLine .h-elformWrap-2 {
    width: 50%;
    margin-bottom: 18px !important;
  }
  /*重点：label和内容宽度，相对于el-form-item容器，不要百分比，改用固定宽度，防止挤压文字换行*/
  .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
    width: 110px !important;
    text-align: right;
    padding-right:12px;
  }
  .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
    margin-left: 110px !important;
  }
  /*输入框、选择器100%填满剩余空间*/
  .yonghu .h-formbLine .el-form-item__content .el-select,
  .yonghu .h-formbLine .el-form-item__content .el-input,
  .yonghu .h-formbLine .el-form-item__content brselect {
    width: 100% !important;
  }
  /*消除inline模式自带inline-block缝隙*/
  .yonghu .h-formbLine .el-form-item {
    display:block !important;
  }

</style>
